<!-- <dx-drawer class="drawer" position="before" [closeOnOutsideClick]="shaderEnabled" [openedStateMode]="menuMode"
  [revealMode]="menuRevealMode" [minSize]="minMenuSize" [shading]="shaderEnabled"
  [rtlEnabled]="currentLang=='ar'?true:false" [(opened)]="menuOpened">
  
  <app-side-navigation-menu
    class="dx-swatch-additional"
    *dxTemplate="let dataMenu of 'panel'"
    (openMenu)="navigationClick()">
      <dx-toolbar id="navigation-header" [rtlEnabled]="currentLang=='ar'?true:false">
        <dxi-item
          *ngIf="minMenuSize !== 0"
          location="before"
          cssClass="menu-button"
          widget="dxButton"
          [options]="{
            icon: 'menu',
            stylingMode: 'text',
            onClick: toggleMenu
          }">
        </dxi-item>
        <dxi-item
          location="before"
          cssClass="header-title"
          [text]="title">
        </dxi-item>
      </dx-toolbar>
  </app-side-navigation-menu>
</dx-drawer>




 <app-header #Header [menuToggleEnabled]="minMenuSize === 0" (menuToggle)="menuOpened = !menuOpened;"
      (_collapsed)="toggelMenue($event)">
    </app-header> 
 -->








<div class="content-flex">

  <div class="menuebar" [ngClass]="{'collpased-menue':collapsed}">
    <app-side-navigation-menu (closeMenueFn)="closeMenueFn($event)"></app-side-navigation-menu>
    <button class="btn-logout" (click)="onLogOut()"><i class="fa-solid fa-right-from-bracket"></i> Logout</button>
  </div>




  <div class="content-outlet" [ngClass]="{
    'left':currentLang=='en','right':currentLang=='ar',
    'collpased-contentOutlet-right':currentLang=='ar'&&collapsed,
    'collpased-contentOutlet-left':currentLang=='en'&&collapsed
  }">


    <app-header #Header (_collapsed)="toggelMenue($event)">
    </app-header>

    <!-- <dx-scroll-view class="layout-body with-footer"> -->
        <ng-content></ng-content>



    <!-- </dx-scroll-view> -->
  </div>


</div>